import PolicyPage from "../components/PolicyPage";

export default function About() {
  return (
    <PolicyPage
      testId="about-page"
      eyebrow="Sumanya · Our Story"
      title="Jewellery you can trust. Since 1991."
      subtitle="For over three decades, jewellery has been more than a business for us — it has been a part of our family, our community and countless celebrations."
      sections={[
        {
          heading: "From Suman Jewellers to Sumanya",
          body: [
            "Suman Jewellers was established in 1991 in Sahebganj, Chapra, Bihar, with a simple philosophy: offer genuine jewellery, transparent pricing and a relationship that lasts far beyond the purchase.",
            "Over the years, generations of customers have trusted us for their gold, diamond and silver jewellery — from everyday pieces to jewellery made for life’s most important occasions.",
            "Today, we are taking that same trust online with Sumanya. While the platform may be new, the experience behind it is not. Every Sumanya product comes with the same commitment to authenticity, quality and transparency that has guided Suman Jewellers since 1991.",
          ],
        },
        {
          heading: "Our Promise",
          body: "We believe buying jewellery should be an experience built on confidence — not confusion. That is why we focus on:",
          bullets: [
            "Authenticity — Genuine jewellery with clearly stated purity and product information.",
            "Transparency — Clear pricing and product details, so you know exactly what you are paying for.",
            "Quality — Carefully selected and crafted jewellery designed to become a part of your story.",
            "Trust — A relationship that does not end after your purchase.",
          ],
        },
        {
          heading: "After-Sales Care",
          body: "Our commitment continues beyond the sale, with lifetime free jewellery cleaning and repair for eligible jewellery, with only additional gold, silver or other material costs applicable where required.",
        },
        {
          heading: "A Legacy We Carry Forward",
          body: [
            "From our showroom in Chapra to customers across India, Sumanya represents the next chapter of our journey.",
            "Suman Jewellers — trusted since 1991. Sumanya — bringing that trust online. Thank you for choosing us to be a part of your special moments.",
          ],
        },
      ]}
    />
  );
}
